// ============================================================================
// LongTurnBanner — "you can close this" notice for a Flow reply that runs long
// ============================================================================

import { Box, IconButton, Typography } from '@mui/material'
import { Close } from '@mui/icons-material'
import { spacing, borderRadius } from '@/theme/muiTheme'
import type { ChatMessage } from '@/hooks/useChat'
import { useLongTurnBanner } from '@/hooks/useLongTurnBanner'

export default function LongTurnBanner({ messages, isStreaming }: { messages: ChatMessage[]; isStreaming: boolean }) {
  const { visible, desktop, computer, dismiss } = useLongTurnBanner(messages, isStreaming)
  const text = desktop
    ? `Working on ${computer ?? 'your computer'}. Keep Beoflow Desktop open there; you can close this page.`
    : 'Flow keeps going even if you close this page. Your answer will be here when you’re back.'
  // The live region is always mounted and only its content changes: screen readers
  // skip a region that arrives already filled.
  return (
    <Box role="status" aria-live="polite">
      {visible && <Box
      sx={{
        mx: spacing.lg,
        mb: spacing.xs,
        px: spacing.md,
        py: spacing.xs,
        display: 'flex',
        alignItems: 'center',
        gap: spacing.sm,
        borderRadius: borderRadius.medium,
        border: '1px solid',
        borderColor: 'divider',
        backgroundColor: 'background.paper',
        flexShrink: 0,
      }}
    >
      <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>
        {text}
      </Typography>
      <IconButton size="small" onClick={dismiss} aria-label="Dismiss">
        <Close fontSize="small" />
      </IconButton>
      </Box>}
    </Box>
  )
}
